import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => {
  return {
    buttonContainer: {
      marginTop: '1rem',
    },
    formTitle: {
      color: '#172B4D',
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '2rem',
    },
    loginHint: {
      color: 'rgba(0, 0, 0, 0.38)',
      fontSize: '0.8rem',
      lineHeight: 1.8,
      marginBottom: '2rem',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '90vh',
      justifyContent: 'center',
      maxWidth: '30.75rem',
    },
  };
});

export default () => {
  const classes = useStyles();
  const history = useHistory();

  const onNavigate = () => history.push('/cases');

  return (
    <Container component="main" className={classes.mainContainer}>
      <Container component="div" disableGutters>
        <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="center">
          Your Case has been submitted
        </Typography>
        <Typography variant="body1" className={`body-copy ${classes.loginHint}`} align="center">
          You have successfully submitted your case on behalf of the patient. An email invitation has been sent to the patient. You can now either create a video report for this
          case or assign it to Mediphany.
        </Typography>
      </Container>
      <Grid container direction="column" justify="center">
        <Grid item className={classes.buttonContainer}>
          <Button variant="contained" color="primary" onClick={onNavigate}>
            Go to Case List
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
